import React, { useEffect, useRef } from 'react';

import { FeatureFlag, Role } from '@ndvr/auth-api';

import { PageContent, PageTopBar } from '@/components/ui/page-layout';
import { useUserHasRole } from 'views/admin/dev-queries';
import { hasStoredOpenPreference, useAiChatSidebarState } from 'views/ai-chat/ai-chat-state';
import { useAssignedFlags } from 'views/auth/auth-queries';
import { useFeatureFlag } from 'views/auth/useFeatureFlag';

import { AccountOnboarding } from './AccountOnboarding/AccountOnboarding';
import { DashboardGrid } from './DashboardGrid';
import { KeyMetrics } from './KeyMetrics';
import { OverdueHouseholds } from './OverdueHouseholds';
import { PracticePulse } from './PracticePulse';
import { ProactiveInsightsList } from './ProactiveInsights/ProactiveInsightsList';
import { SuspendedAccounts } from './SuspendedAccounts';
import { PriorityList } from './TodaysPriorities/PriorityList';

export const Dashboard2Page = () => {
    const { open } = useAiChatSidebarState();
    const hasInitializedSidebar = useRef(false);
    const proactiveInsightsEnabled = useFeatureFlag(FeatureFlag.DASHBOARD_2_PROACTIVE_INSIGHTS);
    const overdueAndTradingDisabledHidden = useFeatureFlag(FeatureFlag.DASHBOARD_2_OVERDUE_AND_TRADING_DISABLED);
    const { isPending: areFeatureFlagsPending } = useAssignedFlags();
    const { data: hasSystemAdminAccess = false } = useUserHasRole(Role.SYSTEM_ADMIN_ACCESS);

    useEffect(() => {
        if (hasInitializedSidebar.current || areFeatureFlagsPending) return;

        hasInitializedSidebar.current = true;

        if (!hasStoredOpenPreference()) {
            open();
        }
    }, [areFeatureFlagsPending, open]);

    return (
        <div className="flex h-full w-full flex-col overflow-hidden bg-white">
            <PageTopBar />
            <PageContent padding="none">
                <DashboardGrid className="p-[16px_32px]">
                    <KeyMetrics />
                    <PriorityList />
                    {proactiveInsightsEnabled && <ProactiveInsightsList />}
                    <PracticePulse />
                    <AccountOnboarding />
                    {hasSystemAdminAccess && !areFeatureFlagsPending && !overdueAndTradingDisabledHidden && (
                        <>
                            <OverdueHouseholds />
                            <SuspendedAccounts />
                        </>
                    )}
                </DashboardGrid>
            </PageContent>
        </div>
    );
};
